export default "/images/amazon.svg?47de085da2d8c24b32724b0ec057402a";